export const Staging = 'https://secure.paytmpayments.com'
export const Production = 'https://secure.paytmpayments.com'